<div class="header">
  <span>{{'Create a new group' | translate}}</span>
</div>
